import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const SuperadminSidebar = () => {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    return (
        <div className="superadmin-sidebar minimized">
            <h5 className="mb-3">Menú</h5>
            <nav className="nav flex-column">
                <Link 
                    className={`nav-link ${isActive('/superadmin/dashboard') ? 'active' : ''}`} 
                    to="/superadmin/dashboard"
                    title="Dashboard"
                >
                    <i className="fas fa-tachometer-alt"></i> <span>Dashboard</span>
                </Link>
                <Link 
                    className={`nav-link ${isActive('/superadmin/clientes') ? 'active' : ''}`} 
                    to="/superadmin/clientes"
                    title="Clientes"
                >
                    <i className="fas fa-building"></i> <span>Clientes</span>
                </Link>
                <Link 
                    className={`nav-link ${isActive('/superadmin/especialidades') ? 'active' : ''}`} 
                    to="/superadmin/especialidades"
                    title="Especialidades"
                >
                    <i className="fas fa-stethoscope"></i> <span>Especialidades</span>
                </Link>
                <Link 
                    className={`nav-link ${isActive('/superadmin/cargos') ? 'active' : ''}`} 
                    to="/superadmin/cargos"
                    title="Cargos"
                >
                    <i className="fas fa-briefcase"></i> <span>Cargos</span>
                </Link>
                <Link 
                    className={`nav-link ${isActive('/superadmin/tipos-contrato') ? 'active' : ''}`} 
                    to="/superadmin/tipos-contrato"
                    title="Tipos de Contrato"
                >
                    <i className="fas fa-file-contract"></i> <span>Tipos de Contrato</span>
                </Link>
                <Link 
                    className={`nav-link ${isActive('/superadmin/plantillas') ? 'active' : ''}`} 
                    to="/superadmin/plantillas"
                    title="Plantillas"
                >
                    <i className="fas fa-file-medical"></i> <span>Plantillas</span>
                </Link>

                <Link 
                    className={`nav-link ${isActive('/superadmin/parametros-fev') ? 'active' : ''}`} 
                    to="/superadmin/parametros-fev"
                    title="Parámetros FEV"
                >
                    <i className="fas fa-file-invoice"></i> <span>Parámetros FEV</span>
                </Link>

                <Link 
                    className={`nav-link ${isActive('/superadmin/parametros') ? 'active' : ''}`} 
                    to="/superadmin/parametros"
                    title="Parámetros Globales"
                >
                    <i className="fas fa-cog"></i> <span>Parámetros Globales</span>
                </Link>
                
                <Link 
                    className={`nav-link ${isActive('/superadmin/noticias') ? 'active' : ''}`} 
                    to="/superadmin/noticias"
                    title="Noticias y Notificaciones"
                >
                    <i className="fas fa-bullhorn"></i> <span>Noticias</span>
                </Link>
                
                <Link 
                    className={`nav-link ${isActive('/superadmin/whatsapp') ? 'active' : ''}`} 
                    to="/superadmin/whatsapp"
                    title="WhatsApp"
                >
                    <i className="fab fa-whatsapp"></i> <span>WhatsApp</span>
                </Link>

                <Link
                    className={`nav-link ${isActive('/superadmin/contrasenas-usuarios') ? 'active' : ''}`}
                    to="/superadmin/contrasenas-usuarios"
                    title="Contraseñas de usuarios"
                >
                    <i className="fas fa-key"></i> <span>Contraseñas</span>
                </Link>

                <Link
                    className={`nav-link ${isActive('/superadmin/sms') ? 'active' : ''}`}
                    to="/superadmin/sms"
                    title="SMS (LabsMobile)"
                >
                    <i className="fas fa-sms"></i> <span>SMS</span>
                </Link>

                <Link
                    className={`nav-link ${isActive('/superadmin/archivos-clinicos') ? 'active' : ''}`}
                    to="/superadmin/archivos-clinicos"
                    title="Archivos clínicos"
                >
                    <i className="fas fa-images"></i> <span>Archivos clínicos</span>
                </Link>
                
            </nav>
        </div>
    );
};

export default SuperadminSidebar;
